import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { initAnalytics } from "@/lib/analytics";

const CONSENT_KEY = "flexaura_cookie_consent";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === "accepted") {
      initAnalytics();
    } else if (!consent) {
      setIsVisible(true);
    }
    // 'rejected' → do nothing, banner stays hidden
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setIsVisible(false);
    initAnalytics();
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, "rejected");
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <Cookie className="w-6 h-6 text-flexaura-teal" />
          </div>

          <div className="flex-1">
            <h3 className="font-heading font-semibold mb-2">We use cookies</h3>
            <p className="text-sm text-muted-foreground mb-4">
              We use analytics cookies to improve your experience. Your financial data is never shared with advertisers.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <Button onClick={handleAccept} variant="gradient" size="sm">
                Accept Cookies
              </Button>
              <Button onClick={handleReject} variant="outline" size="sm">
                Reject Non-Essential
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;